module.exports = "images/france-3.966b40c2.png";